<template>
    <div>
        <banner heading="MANAGERS" description="MANAGERSDESCRIPTION" type="manager"></banner>
        <div class="container">
            <div class="row">
                <manager v-for="manager in managers" :key="manager.id" :manager="manager"></manager>
            </div>
        </div>
    </div>
</template>

<script>
import managerComponent from './Manager.vue';
import banner from './Banner.vue';
import { mapGetters } from 'vuex';
export default {
    name:     'manager-list',
    computed: mapGetters({
        managers: 'allManagers'
    }),
    methods:  { },
    created() {
        this.$store.dispatch('getAllManagers');
    },
    data() {
        return { };
    },
    components: {
        manager: managerComponent,
        banner
    }
};
</script>
